import { useSelector } from 'react-redux'
import { Loading } from '../../common/loading'
import { selectUnreadCount } from '../../layout/store/slice'
import SystemNotificationsFallback from './SystemNotificationsFallback'

const withFallback =
  (Component) =>
  ({ isLoading, isAll, isPopup, todayData, olderData, ...otherProps }) => {
    const todayLength = todayData.length
    const olderLength = olderData.length
    const unreadCount = useSelector(selectUnreadCount)

    if (isLoading && !isPopup)
      return (
        <div style={{ minHeight: 200 }} className={'positionRelative flex1'}>
          <Loading />
        </div>
      )

    if (isAll && todayLength + olderLength === 0)
      return (
        <SystemNotificationsFallback
          isPopup={true}
          isAll={true}
          value={'systemNotifications.NO_ALL_NOTIFICATIONS'}
        />
      )

    if (!isAll && unreadCount === 0)
      return (
        <SystemNotificationsFallback
          isPopup={true}
          value={'systemNotifications.NO_UNREAD_NOTIFICATIONS'}
        />
      )

    return (
      <Component {...otherProps} todayData={todayData} olderData={olderData} />
    )
  }

export default withFallback
